function getCookie(name) {
  var full = '; ' + document.cookie;
  var needle = '; ' + name + '=';
  var startIndex = full.indexOf(needle);
  if (startIndex < 0) return;
  startIndex += needle.length;
  var endIndex = full.indexOf(';', startIndex);
  return full.substring(startIndex, endIndex >= 0 ? endIndex : full.length);
}

class Auth {

  isTeam = undefined

  static setIsTeam(isTeam) {
    this.isTeam = isTeam;
  }

  static checkAndConvertAuthTokenCookie() {
    var authToken = getCookie('auth_token');
    if (authToken) {
      Auth.setAuthToken(authToken);
      document.cookie = 'auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain='+process.env.REACT_APP_COOKIE_DOMAIN+';';
    }
  }

  static isAuth() {
    return !!Auth.getAuthToken();
  }

  static setAuthToken(authToken) {
    localStorage.setItem('auth_token', authToken);
  }

  static getAuthToken() {
    return localStorage.getItem('auth_token');
  }

  static logout() {
    localStorage.removeItem('auth_token');
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/Auth.js